import { useLayoutEffect } from "react";

import { useHandleDeviceUnknown } from "@/hooks";
import { useInfiniteListBuildings, useInfiniteListProperties } from "@/queries";
import { getObjectSearchRoute } from "@/shared/objectSearchDevice";
import { getStorage } from "@/shared/store";
import type { DeviceType } from "@/types";

import { ObjectSearchResults } from "./search-object-results/ObjectSearchResults";

export default function SearchObjectResultWrapper() {
  const deviceType = getStorage("deviceType") as DeviceType;
  const objectSearchRoute = getObjectSearchRoute(deviceType);
  const { toastAndToSelectDevice } = useHandleDeviceUnknown();

  useLayoutEffect(() => {
    if (objectSearchRoute === null) toastAndToSelectDevice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectSearchRoute]);

  if (objectSearchRoute === null) return null;

  if (objectSearchRoute === "PabbitLite") {
    return (
      <ObjectSearchResults
        deviceType={deviceType}
        infiniteQuery={useInfiniteListBuildings}
        dataKey="buildings"
      />
    );
  }

  return (
    <ObjectSearchResults
      deviceType={deviceType}
      infiniteQuery={useInfiniteListProperties}
      dataKey="properties"
    />
  );
}
